import React, { useState } from "react";
import OtpInputBox from "../../../../UI/OtpInputBox";

const SortCode = ({
  validationMsg,
  clearErrors,
  validation,
  trigger,
  getValues,
  backClick,
  saveInputAns,
  onselectAnswer,
  reff,
  clsName,
  setSortCode,
  SkippedLeads,
}) => {
  const [scode, setSCode] = useState("");
  const [error, setError] = useState(false);

  const handlebtnChange = (scode) => {
    setSCode(scode);
    setSortCode(scode);
  };
  const skipNext = () => {
    // let array = JSON.parse(localStorage.getItem('questionData'));
    // array = array.filter(item => item.question_id !== 86);
    // localStorage.setItem('questionData', JSON.stringify(array));
    SkippedLeads("skipFLPSortCode", "sortcode");
  };

  const handleNext = async (e) => {
    if (scode.length != 6) {
      setError(true);
      return;
    } else if (parseInt(scode) === 0) {
      setError(true);
      return;
    } else {
      setError(false);
      saveInputAns(e);
    }
  };

  return (
    <>
      <div
        className={`radio-box animated fadeInUp ${clsName}`}
        id="slide-15"
        ref={reff}
      >
        <h3>
          <b>Please provide your Sort Code</b>
        </h3>
      </div>
      <div className="question-content mt-0 scale-down-ver-center px-3 pb-lg-3 pb-md-3 pb-sm-2 pb-2">
        <div className="row">
          <div className="col-lg-12 mb-2">
            <div className="otp-input">
              <OtpInputBox
                length={6}
                onChange={handlebtnChange}
                className={"otp-input-field"}
              />
            </div>
            {error && (
              <span className="error_msg mt-2">
                Please enter a valid Sort Code
              </span>
            )}
          </div>
          <div className="col-lg-12 mt-2">
            <button
              type="button"
              className="btn-next btncls1"
              id="nextscroll"
              name="sortcode"
              onClick={handleNext}
              data-quest-id={86}
            >
              Next
            </button>
          </div>
          <span className="warning-text">
            {
              "(Please confirm your Sort Code to expedite your claim. If you prefer not to, you can skip this step.)"
            }
          </span>
          <div className="col-lg-12">
          <div className="mb-2 mt-3 text-center">
            <a className="backbtn skip-btn" name="sortcode" onClick={skipNext}>
              {"Skip"}
            </a>
          </div>
        </div>
          <span className="col-12 text-center mt-1">
            <img
              src={"../../../../assets/Quest_VAQ_UB_4_3/img/secure_icon.png"}
              style={{ width: "81px" }}
            />
          </span>
        </div>
        
      </div>
    </>
  );
};

export default SortCode;
